export class ErrorEscalationModel {
    public errorEscalationHashId: string;
    public componentName: string;
    public duplicateEscalationValidationMessage:string;
    public componentHashId : string='';
    public adminLevel : string = 'WEGOADMIN'; 
    public logType: string = '';
    public customerName:string;
    public instanceName: string;
    public wegoAdminHashId : string[] = [];
    public instanceHashId : string = '';
    public instanceAdminHashId:string[] = [];
    public customerHashId : string = '';
    public customerAdminHashId :string[] = [];
    constructor() {
    }
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorescalation-configuration/models/errorescalation.model.ts